exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-3c337cb5]{font-size:15px;text-align:justify}", ""]);

// exports
